<div class="date-picker-input-container">
  <mat-datepicker #picker></mat-datepicker>
  <input
    matInput
    readonly
    [placeholder]="placeholder"
    [formControl]="dateControl"
    [matDatepicker]="picker"
    type="text"
    (click)="picker.open()"
    class="date-picker-input form-control"
  />
  <button
    aria-hidden
    type="button"
    class="date-picker-button calendar"
    (click)="picker.open()"
  ></button>
</div>
